import { takeLatest } from "redux-saga/effects";
import { actionTypes } from "../actions";
import { fetchWalletOffersSaga } from "./fetchWalletOffersSaga";

export function* watchGetWalletOffer() {
  yield takeLatest(actionTypes.FETCH_WALLET_OFFERS, fetchWalletOffersSaga);
}
